import { render, staticRenderFns } from "./CourseStructureSlidebar.vue?vue&type=template&id=54f5d862"
import script from "./CourseStructureSlidebar.vue?vue&type=script&lang=js"
export * from "./CourseStructureSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports